import { HttpErrorResponse, HttpEvent, HttpHandler, HttpHeaders, HttpInterceptor, HttpRequest } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { Observable, of, throwError } from "rxjs";

import { Router } from "@angular/router";
import { catchError, finalize } from "rxjs/operators";
import { LoadingService } from "../loading.service";

@Injectable()
export class InterceptorService implements HttpInterceptor {

  private totalRequests = 0;
  tk = localStorage.getItem("token");
  headers = new HttpHeaders({ Authorization: `Bearer ${this.tk}` });

  constructor(private _loading: LoadingService, private router: Router) { }

  private handleAuthError(err: HttpErrorResponse): Observable<any> {
    this._loading.setLoading(false, err.url);
    if (err.status === 401 || err.status === 403) {
      this.router.navigateByUrl(`/login`);
      return of(err.message);
    }
    return throwError(err);
  }

  intercept(
    request: HttpRequest<any>,
    next: HttpHandler
  ): Observable<HttpEvent<any>> {
    if (request.url.includes('viacep.com.br')) {
      return next.handle(request);
    }

    this.totalRequests++;
    this._loading.setLoading(true, request.url);
    if (request.headers.get("anonymous")) {
      request = request.clone({
        headers: new HttpHeaders(),
      });
    }
    if (localStorage.getItem("token")) {
      request = request.clone({
        setHeaders: {
          Authorization: `Bearer ${localStorage.getItem("token")}`,
        },
      });
    }

    request = request.clone({
      setHeaders: {
        'Cache-Control': 'no-cache, no-store, must-revalidate',
        'Pragma': 'no-cache',
        'Expires': '0'
      }
    });

    return next
      .handle(request)
      .pipe(
        catchError((error) => {
          return this.handleAuthError(error)
        }),
        finalize(() => {
          this.totalRequests--;
          if (this.totalRequests === 0) {
            this._loading.setLoading(false, request.url);
          }
        })
      )
  }
}
